<fullscreen-page>
    <content-column>
        <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">

            <div class="d-flex flex-row flex-grow-1 overflow-hidden">

                <div class="flex-grow-1 h-100 overflow-auto p-3">

                    <dx-list
                        class="catalog-dx-list"
                        [dataSource]="catalogs"
                        [searchEnabled]="true"
                        searchExpr="name"
                        searchMode="contains"
                        [searchEditorOptions]="{ placeholder: ('Kataloge suchen…' | translate), showClearButton: true }"
                        selectionMode="single"
                        keyExpr="id"
                        [selectedItemKeys]="selectedCatalogId ? [selectedCatalogId] : []"
                        (onItemClick)="onRowClick($event.itemData)"
                        noDataText="{{ 'Keine Kataloge in der Golden Record Stage' | translate }}">

                        <div *dxTemplate="let catalog of 'item'">
                            <div class="catalog-row"
                                 [class.catalog-row--selected]="selectedCatalogId === catalog.id"
                                 [class.catalog-row--active]="catalog.isGoldenRecord"
                                 (dblclick)="openCatalog(catalog.id)">

                                <button type="button"
                                        class="golden-record-crown-btn"
                                        [class.golden-record-crown-btn--active]="catalog.isGoldenRecord"
                                        [title]="(catalog.isGoldenRecord ? 'Aktueller Golden Record' : 'Als Golden Record festlegen') | translate"
                                        (click)="onCrownClick(catalog, $event)">
                                    <i class="icon-glyphicons-basic-425-crown"></i>
                                </button>

                                <div class="catalog-row__main">
                                    <div class="catalog-row__title">
                                        {{ catalog.name }}
                                    </div>
                                    <div class="catalog-row__subtitle">
                                        {{ catalog.date | date:'dd.MM.yyyy, HH:mm' }}
                                    </div>
                                </div>

                                <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                    <dx-button
                                        icon="export"
                                        stylingMode="text"
                                        type="default"
                                        [hint]="'Katalog öffnen' | translate"
                                        (onClick)="openCatalog(catalog.id)">
                                    </dx-button>
                                    <dx-button
                                        icon="overflow"
                                        stylingMode="text"
                                        type="default"
                                        (onClick)="openRowMenu($event, catalog)">
                                    </dx-button>
                                </div>
                            </div>
                        </div>
                    </dx-list>

                    <dx-context-menu
                        #rowMenu
                        [dataSource]="currentMenuItems"
                        [width]="220"
                        [showEvent]="''"
                        [position]="{ my: 'left top', at: 'left bottom' }"
                        (onItemClick)="onMenuItemClick($event)">
                    </dx-context-menu>
                </div>

                <np-inspect-panel
                    context="containerCatalog"
                    [catalogId]="selectedCatalogId"
                    [titleOverride]="selectedCatalogName"
                    [logoLink]="selectedCatalogLogo">
                </np-inspect-panel>

            </div>
        </div>
    </content-column>
</fullscreen-page>

<dx-popup
    title="{{ 'Datensicherungen' | translate }}" 
    [width]="1000"
    [height]="800"
    [dragEnabled]="false"
    [showCloseButton]="true"
    [hideOnOutsideClick]="true"
    [(visible)]="backUpVisible"
    contentTemplate="popupContent">
    <div *dxTemplate="let data of 'popupContent'">
        <backup></backup>
    </div>
</dx-popup>
